module.exports = __webpack_public_path__ + "img/domonetizationLeads.aaf5ce17.svg";